import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import Form from '../Form';
import TextTabContent from './TextTabContent/TextTabContent';
import KeyParamsTabContent from './KeyParamsTabContent/KeyParamsTabContent';
import StepByStepTabContent from './StepByStepTabContent/StepByStepTabContent';
import OverviewTabContent from './OverviewTabContent/OverviewTabContent';
import { States } from '../../features/PpiContainer/constants';
import PpiToolbarContent from './PpiToolbarContent';
import { dataLabelsPropTypes } from '../Form/propTypes';
import { Mode, modePropType } from './constants';
import VersionsTabContent from './VersionsTabContent/VersionsTabContent';
import WhereUsedTabContent from './WhereUsedTabContent/WhereUsedTabContent';
import { useSelector } from 'react-redux';
import { getGlobalVariantDialog } from 'features/PpiContainer/selectors';
import PpiCreateVariantGlobalView from 'views/PpiCreateVariantGlobalView';
import { toJS } from 'utils/immutableUtils';

const PpiForm = ({
  data,
  relationshipId,
  defaultData,
  showProgress,
  dataLabels,
  mode,
  onSave,
  onPublish,
  onUnpublish,
  onCreateDraft,
  oniFoodUpdatePpi,
  onGlobalUpdatePpi,
  setOpenConfirm,
  completePpiData = null,
  globalPpis
}) => {
  const { formatMessage } = useIntl();
  const dialog = useSelector(getGlobalVariantDialog);
  const dialogState = toJS(dialog);

  function inDraftOrCreateForm({ enrichmentStatus }) {
    return enrichmentStatus === States.DRAFT || mode === Mode.CREATE;
  }

  function isNotInCreateMode() {
    return mode !== Mode.CREATE;
  }

  function mergeDataLabels() {
    return {
      titleContext: () => formatMessage({ id: 'ppi.titleContent' }),
      ...dataLabels
    };
  }
  // console.log(data)
  return (
    <>
      <Form
        data={data}
        defaultData={defaultData}
        tabs={[
          {
            name: 'text',
            label: 'ppi.textTab',
            TabContent: TextTabContent,
            visible: inDraftOrCreateForm
          },
          {
            name: 'keyparameters',
            label: 'ppi.keyParametersTab',
            TabContent: KeyParamsTabContent,
            visible: inDraftOrCreateForm
          },
          {
            name: 'stepbystep',
            label: 'ppi.stepByStepTab',
            TabContent: StepByStepTabContent,
            visible: inDraftOrCreateForm
          },
          {
            name: 'overview',
            label: 'ppi.overviewTab',
            TabContent: OverviewTabContent,
            tabContentPadding: 'none'
          },
          {
            name: 'whereused',
            label: 'ppi.whereUsedTab',
            TabContent: WhereUsedTabContent,
            visible: isNotInCreateMode
          },
          {
            name: 'versions',
            label: 'ppi.versionsTab',
            TabContent: VersionsTabContent,
            visible: isNotInCreateMode
          }
        ]}
        dataLabels={mergeDataLabels()}
        showProgress={showProgress}
        ToolbarContent={({ data: formData }) => (
          <PpiToolbarContent
            data={formData}
            relationshipId={relationshipId}
            mode={mode}
            onSave={onSave}
            onPublish={onPublish}
            oniFoodUpdatePpi={oniFoodUpdatePpi}
            onUnpublish={onUnpublish}
            onCreateDraft={onCreateDraft}
            completePpiData={completePpiData}
            onGlobalUpdatePpi={onGlobalUpdatePpi}
            setOpenConfirm={setOpenConfirm}
            globalPpis={globalPpis}
          />
        )}
      />
      {dialogState && dialogState.open && (
        <PpiCreateVariantGlobalView data={data} />
      )}
    </>
  );
};

PpiForm.propTypes = {
  data: PropTypes.object,
  defaultData: PropTypes.object,
  dataLabels: PropTypes.shape(dataLabelsPropTypes),
  showProgress: PropTypes.bool,
  mode: modePropType.isRequired,
  onSave: PropTypes.func,
  onPublish: PropTypes.func,
  onUnpublish: PropTypes.func,
  onCreateDraft: PropTypes.func
};

export default PpiForm;
